/**
 * manageSysManageSourceManageSyncModule
 * author: Qian.qianchen 2019-02-13
 * description: 同步来源
 */
"use strict";
angular.module('manageSysManageSourceManageSyncModule', [])
    .controller('manageSysManageSourceManageSyncCtrl', ['$scope', "$modalInstance", '$validation', '$timeout', 'modalDialog', 'trsHttpService', '$q',
        function($scope, $modalInstance, $validation, $timeout, modalDialog, trsHttpService, $q) {
            initStatus();
            initData();
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status = {
                    keywords: '',
                    selectedColumn: 'WZ',
                    columnList: {
                        'WZ': { name: '网站栏目', value: 'wz' },
                        'APP': { name: 'APP栏目', value: 'app' },
                        'WX': { name: '微信公众号', value: 'wx' },
                        'SZB': { name: '数字报刊', value: 'szb' },
                    }
                };
                $scope.data = {
                    columnArr: [],
                    allSelectData: [],
                    allSources: {}
                }
            }
            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                getColumnData();
            }
            /**
             * [getColumnData description] 获取全部渠道数据
             * @return {[type]} [description]
             */
            function getColumnData() {
                var defer = $q.defer();
                var params = {
                    "serviceid": "mlf_personalsource",
                    "methodname": "pullSources"
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.allSources = {};
                    $scope.data.allSelectData = []; //重置
                    for (var key in data) {
                        var selectedArr = new Array();
                        data[key].data.forEach(function(item, index) {
                            if (item.isTake) {
                                $scope.data.allSelectData.push(item);
                                selectedArr.push(item);
                            }
                        });
                        // 已选数据
                        $scope.data.allSources[key] = {
                            column: key,
                            initSelectData: selectedArr,
                            selectedData: selectedArr.concat([]),
                            showArr: selectedArr.slice(0, 4),
                            allData: data[key].data,
                            showData: data[key].data.slice(0, 14),
                            name: $scope.status.columnList[key].name,
                            loadMore: false
                        }
                        if ($scope.status.selectedColumn == key) {
                            $scope.data.columnArr = data[key].data.slice(0, 14);
                        }
                    }
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [scrollShowMore description]滑动加载更多
             * @return {[type]} [description]
             */
            $scope.scrollShowMore = function() {
                var cloumn = $scope.status.selectedColumn;
                var curPosition = $scope.data.columnArr.length;
                // 如果是搜索数据，且搜索数据大于0
                if ($scope.data.allSources[cloumn].searchData && $scope.data.allSources[cloumn].searchData.length > 0) {
                    var newArr = $scope.data.allSources[cloumn].searchData.slice(curPosition, curPosition + 14);
                    $scope.data.columnArr = $scope.data.columnArr.concat(newArr);
                } else {
                    var newArr = $scope.data.allSources[cloumn].allData.slice(curPosition, curPosition + 14);
                    $scope.data.allSources[cloumn].showData = $scope.data.allSources[cloumn].showData.concat(newArr);
                    $scope.data.columnArr = $scope.data.allSources[cloumn].showData.concat(newArr);
                }
            }
            /**
             * [selectSource description] 来源添加
             * @param  {[type]} sourceArr [description] 来源数组
             * @return {[type]}           [description]
             */
            function selectSource(sourceArr) {
                var defer = $q.defer();
                var ids = sourceArr.map(function(item) {
                    return item.id;
                }).join(',');
                if (ids) {
                    var params = {
                        "serviceid": "mlf_personalsource",
                        "methodname": "takeSources",
                        "bigdataIds": ids
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        defer.resolve(data);
                    });
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }
            /**
             * [unselectSource description] 来源删除
             * @param  {[type]} sourceArr [description] 来源数组
             * @return {[type]}           [description]
             */
            function unselectSource(sourceArr) {
                var defer = $q.defer();
                var ids = sourceArr.map(function(item) {
                    return item.id;
                }).join(',');
                if (ids) {
                    var params = {
                        "serviceid": "mlf_personalsource",
                        "methodname": "deleteSources",
                        "bigdataIds": ids
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        defer.resolve(data);
                    });
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }
            /**
             * [equal description] 判断两个对象是否相等
             * @param  {[type]} obj1 [description] 对象1
             * @param  {[type]} obj2 [description] 对象2
             * @return {[type]}      [description]
             */
            function equal(obj1, obj2) {
                var result = true;
                for (var k in obj1) {
                    if (obj1[k] != obj2[k]) {
                        result = false;
                        break;
                    }
                }
                return result;
            }
            /**
             * [ArrContainObj description] 判断数组中是否含有某个对象
             * @param {[type]} arr [description] 数组
             * @param {[type]} obj [description] 对象
             */
            function ArrContainObj(arr, obj) {
                var count = 0;
                for (var i = 0; i < arr.length; i++) {
                    if (equal(arr[i], obj)) {
                        return i;
                    } else {
                        count++;
                    }
                }
                if (count == arr.length) {
                    return -1;
                }
            }

            /**
             * [tabEnter description] 鼠标移入tab时方法
             * @param  {[type]} tab [description] tab对象
             * @return {[type]}     [description]
             */
            $scope.tabEnter = function(tab, ev) {
                ev.stopPropagation();
                tab.mouseEnter = true;
            }
            /**
             * [tabLeave description] 鼠标移出tab时方法
             * @param  {[type]} tab [description] tab对象
             * @return {[type]}     [description]
             */
            $scope.tabLeave = function(tab, ev) {
                ev.stopPropagation();
                tab.mouseEnter = false;
            }
            /**
             * [tabInit description] tab对象初始化
             * @param  {[type]} tab [description] tab对象
             * @return {[type]}     [description]
             */
            $scope.tabInit = function(tab) {
                tab.mouseEnter = false;
            }
            /**
             * [itemIsSelected description] 来源是否已被选中
             * @param  {[type]} item [description]来源
             * @return {[type]}      [description]
             */
            $scope.itemIsSelected = function(item) {
                var flag = {
                    flag: false,
                };
                var colStr = $scope.status.selectedColumn;
                if (ArrContainObj($scope.data.allSources[colStr].selectedData, item) > -1) {
                    flag = {
                        flag: true
                    };
                    return flag;
                }
                return flag;
            }
            /**
             * [selectToggle description] 来源选中/取消选中
             * @param  {[type]} item [description] 来源
             * @return {[type]}      [description]
             */
            $scope.selectToggle = function(item) {
                var colStr = $scope.status.selectedColumn;
                var idxSelect = ArrContainObj($scope.data.allSources[colStr].selectedData, item);
                if (idxSelect > -1) { // 取消选中
                    $scope.data.allSources[colStr].selectedData.splice(idxSelect, 1);
                    if (idxSelect <= 3) { // 如果移除的元素在显示的4条内，则把showArr中的移除
                        $scope.data.allSources[colStr].showArr = $scope.data.allSources[colStr].selectedData.slice(0, 4);
                    }
                } else { // 选中
                    $scope.data.allSources[colStr].selectedData.unshift(item);
                    $scope.data.allSources[colStr].showArr = $scope.data.allSources[colStr].selectedData.slice(0, 4);
                }
            }
            /**
             * [itemUnselect description] 来源移除
             * @param  {[type]} section [description] 栏目
             * @param  {[type]} item [description] 来源
             * @return {[type]}      [description]
             */
            $scope.itemUnselect = function(section, item) {
                // 移除showArr的元素
                var idx0 = ArrContainObj(section.selectedData, item);
                section.selectedData.splice(idx0, 1);
                if (idx0 <= 3) { // 如果移除的元素在显示的4条内，则把showArr中的移除
                    section.showArr = section.selectedData.slice(0, 4);
                }
            }
            /**
             * [tabClick description] 栏目tab切换方法
             * @param  {[type]} tab [description] 栏目tab
             * @return {[type]}     [description]
             */
            $scope.tabClick = function(key, tab) {
                $scope.data.allSources[key].searchData = [];
                $scope.status.selectedColumn = key;
                $scope.status.keywords = ''; // 搜索框值重置
                $scope.data.allSources[key].searchData = null;
                $scope.data.columnArr = $scope.data.allSources[key].allData.slice(0, 14);
            }
            /**
             * [allSelect description] 来源全部添加
             * @param  {[type]} tab [description] 选中的栏目
             * @param  {[type]} ev  [description] event
             * @return {[type]}     [description]
             */
            $scope.allSelect = function(key, tab, ev) {
                ev.stopPropagation();
                if ($scope.data.allSources[key].allData.length == $scope.data.allSources[key].selectedData.length) {
                    return;
                }
                $scope.data.allSources[key].selectedData = angular.copy($scope.data.allSources[key].allData);
                $scope.data.allSources[key].showArr = $scope.data.allSources[key].selectedData.slice(0, 4);

            }
            /**
             * [allUnselect description] 来源全部移除
             * @param  {[type]} section [description] 栏目信息
             * @return {[type]}         [description]
             */
            $scope.allUnselect = function(section) {
                section.selectedData = [];
                section.showArr = [];
            }
            /**
             * [loadMore description] 加载更多
             * @param  {[type]} section [description] 选择区域
             * @return {[type]}         [description]
             */
            $scope.loadMore = function(section) {
                if (section.showArr.length <= 4) {
                    section.showArr = section.selectedData;
                } else {
                    section.showArr = section.selectedData.slice(0, 4);
                }
            }
            /**
             * [isAllSelected description] 判断是否为全选
             * @param  {[type]}  tab [description]
             * @return {Boolean}     [description]
             */
            $scope.isAllSelected = function(key) {
                if ($scope.data.allSources[key].selectedData.length == $scope.data.allSources[key].allData.length) {
                    return false;
                } else {
                    return true;
                }
            }
            /**
             * [fullTextSearch description] 搜索
             * @param  {[type]} ev [description] event事件对象
             * @return {[type]}    [description]
             */
            $scope.fullTextSearch = function(ev) {
                if (angular.isDefined(ev) && ev.keyCode == 13) {
                    var params = {
                        "serviceid": "mlf_personalsource",
                        "methodname": "pullSources",
                        "section": $scope.status.selectedColumn.toLowerCase(),
                        "SrcName": $scope.status.keywords
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.data.allSources[$scope.status.selectedColumn].searchData = data[$scope.status.selectedColumn].data;
                        $scope.data.columnArr = data[$scope.status.selectedColumn].data.slice(0, 14);
                    });
                }
            }
            /**
             * [cancel description:取消]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
                //$modalInstance.close();
            };
            /**
             * [confirm description:确定]
             */
            $scope.confirm = function() {
                // 算出当前选中的data状态；
                let curAllSelectData = []; // 当前所有选中的状态，包括已选和未选
                let selectedArr = []; // 选中的
                let unSelectedArr = []; // 未选中的
                for (let key in $scope.data.allSources) {
                    curAllSelectData = curAllSelectData.concat($scope.data.allSources[key].selectedData);
                }
                // 计算curAllSelectData在$scope.data.allSelectData中没有的元素，即选的元素
                selectedArr = curAllSelectData.filter((item, index) => {
                    return $scope.data.allSelectData.every((_item, index) => {
                        return item.id != _item.id;
                    })
                })
                // 计算$scope.data.allSelectData在curAllSelectData中没有的元素，即未选的元素
                unSelectedArr = $scope.data.allSelectData.filter((item, index) => {
                    return curAllSelectData.every((_item, index) => {
                        return item.id != _item.id;
                    })
                })
                $scope.loadingPromise = $q.all([selectSource(selectedArr), unselectSource(unSelectedArr)]).then(function(data) {
                    modalDialog.alertType("同步来源成功", "", "success", false);
                    $modalInstance.close();
                });
            };
        }
    ]);